import { authAPI } from './api';

export interface ForgotPasswordRequest {
  email: string;
}

export interface ResetPasswordRequest {
  token: string;
  new_password: string;
}

export interface ForgotPasswordResponse {
  message: string;
}

export interface ResetPasswordResponse {
  message: string;
}

export const requestPasswordReset = async (
  email: string,
): Promise<ForgotPasswordResponse> => {
  const { data } = await authAPI.post<ForgotPasswordResponse>(
    '/auth/forgot-password',
    { email },
  );
  return data;
};

export const resetPassword = async (
  token: string,
  newPassword: string,
): Promise<ResetPasswordResponse> => {
  const { data } = await authAPI.post<ResetPasswordResponse>(
    '/auth/reset-password',
    { token, new_password: newPassword },
  );
  return data;
};

